import axios from "../utils/axios";

export const createChapter = (payload) => {
  return axios
    .post("/api/chapters/create", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const updateChapter = (chapterId, payload) => {
  return axios
    .put(`/api/chapters/${chapterId}/update`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getChapters = (payload) => {
  return axios
    .get(`/api/chapters`, {
      params: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const deleteChapter = (id) => {
  return axios
    .delete(`/api/chapters/${id}/delete`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
